import React from "react";
import { object, number } from "prop-types";

import StoryElements from "../story-elements";
import StorySideBar from "../story-sidebar";
import VideoHeaderBlock from "./video-header-block";
import { AdContainer } from "../../ads";

import "./video.m.css";
import StorySeparator from "../../atoms/story-separator";
import useDevice from "../../helper/custom-hook/useDevice";
import useAdType from "../../helper/custom-hook/useAdType";

const getPrimaryVideo = (cards) => {
  const headerVideo = [];
  cards.forEach((card) => {
    card["story-elements"].forEach((element) => {
      if (element.type === "youtube-video" || element.subtype === "dailymotion-video") {
        headerVideo.push(element);
      }
    });
  });
  return headerVideo[0];
};

const getCards = (cards, id) => {
  let storyCards = [];
  cards.forEach((card) => {
    const newCard = Object.assign({}, card);
    let elements = [];
    card["story-elements"].map((element) => {
      if (element.id !== id) {
        elements = [...elements, element];
      }
    });
    newCard["story-elements"] = elements;
    storyCards = [...storyCards, newCard];
  });
  return storyCards;
};

const VideoStory = ({ story, index }) => {
  let primaryVideo = null;
  let cards = story.cards;
  const adType = useAdType();
  const isReview = story["story-template"] === "review";
  const isMobile = useDevice();

  if (!isReview) {
    primaryVideo = getPrimaryVideo(story.cards);
    cards = primaryVideo ? getCards(story.cards, primaryVideo.id) : story.cards;
  }

  return (
    <>
      {index > 0 && <StorySeparator />}
      <div styleName="story-wrapper">
        <div styleName="ad-wrapper" className="hide-desktop">
          <AdContainer
            AdClassName="standard-320x50"
            id={adType === "izooto" ? "div-gpt-ad-1711631114518-0" : "div-gpt-ad-1675837489260-0"}
            mobile={adType === "izooto" ? "PV_MWeb_AP_Top_ym" : "PV_MWeb_AP_Top"}
            isExternalAdPath={adType === "izooto"}
          />
        </div>
        <div className="story-section">
          <div>
            <VideoHeaderBlock story={story} primaryVideo={primaryVideo} isReview={isReview} index={index} />
            <StoryElements story={story} cards={cards} index={index} />
          </div>
        </div>
        {!isMobile && (
          <div className="side-story-section ">
            <StorySideBar index={index} story={story} />
          </div>
        )}
      </div>
    </>
  );
};

VideoStory.propTypes = {
  story: object,
  index: number
};

export default VideoStory;
